// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background-overlay {
  background-image: url('email-confiramation-header-bg.png');
  background-repeat: no-repeat;
  background-position: top center;
  background-size: auto;
  position: relative;
  background-color: #000;
}
.background-overlay::before {
  content: "";
  background-color: rgba(18, 18, 18, 0.8);
  display: block;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 1;
}

.header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px 0 20px;
}

.awaiting-subtitle {
  font-family: var(--ion-font-family);
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  color: #ffffff;
  margin: 12px 0 0;
  padding: 0 10px;
}

.qr-placeholder {
  width: 225px;
  height: 225px;
}

.awaiting-secondary {
  font-family: var(--ion-font-family);
  font-size: 12px;
  font-weight: 400;
  line-height: 130%;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  margin: 80px 0 0;
  padding: 0 10px;
}

.logo {
  --icon-color: black;
  height: 36px;
  width: 85px;
  margin-bottom: 20px;
}

.title {
  font-family: var(--ion-font-family);
  font-weight: 700;
  font-size: 22px;
  line-height: 130%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
}
.title.accent {
  color: #ffffff;
}

.container-all {
  height: 100dvh;
}
.container-all .wrapper-left {
  display: flex;
  justify-content: center;
  align-self: center;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #faf7f6;
}
.container-all .wrapper-left ion-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.container-all.wrapper-info {
  overflow: auto;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 1;
  padding: 0 20px;
}
.container-all.wrapper-info ion-button {
  width: 100%;
  text-wrap: auto;
  background-color: #fff;
  color: #231f20;
  font-family: var(--ion-font-family);
  font-size: 16px;
  font-weight: 700;
  line-height: 130%;
  text-align: center;
  vertical-align: middle;
  padding: 0;
  min-height: 50px;
  text-transform: none;
}
.container-all.wrapper-info ion-button span {
  padding-top: 3px;
}
.container-all.wrapper-info ion-button.btn-eintracht {
  font-family: AppFontEintrachtOFCSans;
  background-color: #e30613;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 700;
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  color: #fff;
  box-sizing: border-box;
  --border-color: transparent;
  z-index: 1;
}
.container-all.wrapper-info ion-button.btn-eintracht span {
  padding-top: 0;
  padding-bottom: 3px;
}
.container-all.wrapper-info .main-card {
  flex-grow: 1;
  background: #231f20;
  border-radius: 5px 5px 0 0;
  color: #ffffff;
}
.container-all.wrapper-info ion-card {
  text-align: initial;
  border: none;
  box-shadow: none;
  background: transparent;
  --color: var(--color-black);
  --preorder-type-chip-border-color: var(--ion-color-primary);
  overflow: auto;
  word-break: break-word;
}
.container-all.wrapper-info ion-card ion-card-header {
  background: white;
  color: var(--color-black);
  padding: 0;
  padding-bottom: 8px;
  border-bottom: 0.3px solid rgba(126, 167, 105, 0.4509803922);
}
.container-all.wrapper-info ion-card ion-card-header .separator {
  margin-block: 20px;
}
.container-all.wrapper-info ion-card ion-card-header ion-button {
  --background: transparent;
  --color: #54504c;
  text-transform: none;
}
.container-all.wrapper-info ion-card ion-card-content:first-of-type {
  padding: 0;
  border: none;
}
.container-all.wrapper-info ion-card ion-card-content .padding-card {
  padding: 10px;
}
.container-all.wrapper-info ion-card ion-card-title {
  font-family: var(--ion-font-family);
  color: var(--color-white);
  font-size: 18px;
}
.container-all.wrapper-info ion-card .icon-edit {
  zoom: 1.3;
}
.container-all.wrapper-info ion-card .left-col {
  text-align: left;
}
.container-all.wrapper-info ion-card .right-col {
  text-align: right;
}

.item-row {
  padding: 25px 20px 20px 20px;
  border-bottom: 1px solid #383838;
}
.item-row:last-child {
  border-bottom: none;
  padding-bottom: 30px;
}

.article-name {
  padding: 0;
  font-family: var(--ion-font-family);
  font-size: 12px;
  line-height: 120%;
  text-transform: capitalize;
}

.article-price {
  padding: 0;
  font-family: var(--ion-font-family);
  font-size: 12px;
  line-height: 120%;
  vertical-align: middle;
  text-transform: capitalize;
}

.option-block {
  padding: 0;
}

.option-name {
  font-family: var(--ion-font-family);
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: bottom;
  text-transform: uppercase;
  margin-bottom: 3px;
}

.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.table-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3019607843);
}
.table-row .table-title,
.table-row .table-sum {
  font-family: var(--ion-font-family);
  color: var(--color-white);
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: bottom;
  text-transform: uppercase;
}

.total-row {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  padding: 10px 18px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3019607843);
}
.total-row .total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  width: 100%;
}
.total-row .total-title,
.total-row .total-sum {
  font-family: var(--ion-font-family);
  color: var(--color-white);
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: bottom;
  text-transform: uppercase;
}

.sub-total {
  color: var(--color-white);
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-bottom: 8px;
}
.sub-total .sub-total-title,
.sub-total .sub-total-sum {
  font-family: var(--ion-font-family);
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 8%;
  vertical-align: middle;
  text-transform: uppercase;
}

.button-block {
  width: 100%;
  padding-bottom: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.main-card-wrapper {
  background: #231f20;
  border-radius: 5px 5px 0 0;
  color: #ffffff;
  margin-bottom: -20px;
}
.main-card-wrapper .pickup-location {
  border-bottom: 1px solid #383838;
}
.main-card-wrapper .pickup-location p {
  font-family: var(--ion-font-family);
  font-size: 12px;
  font-weight: 500;
  line-height: 130%;
  margin-top: 20px;
  margin-bottom: 28px;
  padding: 0 20px;
}
.main-card-wrapper .pickup-location .pickup-location__content {
  display: flex;
}
.main-card-wrapper .pickup-location .pickup-location__content .pickup-location-text {
  margin-left: 15px;
}

.header-sliders {
  display: flex;
  justify-content: space-between;
  padding: 15px 0px;
}
.header-sliders .step {
  width: 32%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.header-sliders .step .line {
  width: 100%;
  height: 9px;
  background-color: #383838;
}
.header-sliders .step .line.selected {
  background-color: #fff;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    background-color: var(--ion-color-white);
    opacity: 1;
  }
  50% {
    background-color: var(--ion-color-white);
    opacity: 0.5;
  }
}
@keyframes pulse-eintracht {
  0%, 100% {
    background-color: #d10d1d;
    opacity: 1;
  }
  50% {
    background-color: #d10d1d;
    opacity: 0.5;
  }
}
.pickup-status {
  padding: 20px 20px 0 20px;
  border-bottom: 1px solid #383838;
}
.pickup-status h3 {
  font-family: var(--ion-font-family);
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  vertical-align: middle;
}
.pickup-status h3 span {
  font-weight: 500;
}

.burger-menu {
  position: absolute;
  top: 15px;
  left: 20px;
  z-index: 1;
}

.eintracht-header {
  background: #000000;
}
.eintracht-header ion-toolbar {
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
  --background: #000000;
  --min-height: 0;
  --padding-top: 12px;
  --padding-bottom: 0;
  --padding-start: 20px;
  --padding-end: 20px;
}

.eintracht {
  --background: #000000;
}
.eintracht .background-overlay {
  background: #000000;
}
.eintracht .background-overlay::before {
  display: none;
}
.eintracht .container-all {
  height: calc(100dvh - 50px);
}
.eintracht .container-all.wrapper-info {
  justify-content: flex-start;
  gap: 16px;
  padding: 32px 20px 0;
}
.eintracht .container-all.wrapper-info .main-card {
  flex-grow: 0;
  background: transparent;
}
.eintracht .container-all.wrapper-info ion-button.btn-eintracht {
  --background: #ffffff;
  --border-color: var(--ion-color-eintracht-red);
  --border-width: 1px;
  --border-style: solid;
  --border-radius: 6px;
  --box-shadow: none;
  height: 50px;
  min-height: 50px;
  margin: 0;
  background: #ffffff;
  border: 1px solid var(--ion-color-eintracht-red);
  color: #000000;
  font-family: AppFontEintrachtSansOFCBold;
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
}
.eintracht .container-all.wrapper-info ion-button.btn-eintracht span {
  padding: 0;
}
.eintracht .header {
  align-items: stretch;
  gap: 8px;
  padding: 20px 16px;
  background: #232323;
  border-radius: 20px;
}
.eintracht .header:has(qrcode) {
  align-items: center;
  gap: 16px;
}
.eintracht .header qrcode {
  display: flex;
  justify-content: center;
  height: 163px;
  line-height: 0;
}
.eintracht .header qrcode ::ng-deep canvas,
.eintracht .header qrcode ::ng-deep img {
  width: 163px !important;
  height: 163px !important;
  border-radius: 6px;
}
.eintracht .title {
  margin: 0;
  padding: 0;
  background: transparent;
  color: #ffffff;
  font-family: AppFont, sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 120%;
  text-align: left;
}
.eintracht .awaiting-subtitle,
.eintracht .awaiting-secondary {
  margin: 0;
  padding: 0;
  color: #ffffff;
  font-family: AppFont, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  text-align: left;
}
.eintracht .awaiting-secondary {
  margin-top: 11px;
}
.eintracht h2.awaiting-secondary {
  align-self: stretch;
  margin-top: 0;
}
.eintracht .main-card-wrapper {
  min-height: 500px;
  margin-bottom: 0;
  background: #232323;
  border-radius: 20px;
  overflow: hidden;
}
.eintracht .main-card-wrapper .pickup-location {
  padding: 48px 21px 16px;
  border-bottom: 1px solid #383838;
}
.eintracht .main-card-wrapper .pickup-location .pickup-location__content .pickup-location-text {
  margin-left: 0;
  font-family: AppFont, sans-serif;
}
.eintracht .main-card-wrapper .pickup-location p {
  margin: 0;
  padding: 0;
  font-family: AppFont, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 120%;
}
.eintracht .main-card-wrapper .pickup-location .amex-farewell {
  margin-top: 24px;
}
.eintracht .pickup-status {
  padding: 20px 21px 0;
  border-bottom: 1px solid #383838;
}
.eintracht .pickup-status h3 {
  font-family: AppFont, sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 100%;
}
.eintracht .pickup-status h3 span {
  font-weight: 700;
}
.eintracht .header-sliders {
  gap: 8px;
  padding: 11px 0 15px;
}
.eintracht .header-sliders .step {
  width: auto;
  flex: 1;
}
.eintracht .header-sliders .step .line {
  height: 9px;
  background-color: #0f0f0f;
}
.eintracht .header-sliders .step .line.selected {
  background: #d10d1d;
  animation: pulse-eintracht 2s infinite;
}
.eintracht .pickup-location-text h3.order-number {
  margin: 0 0 11px;
  font-family: AppFontEintrachtOFC;
  font-size: 28px;
  font-weight: 400;
  line-height: 110%;
  text-transform: uppercase;
}
.eintracht .pickup-location-text h3.order-number span {
  padding: 0;
  background: transparent;
  color: #ffffff;
}
.eintracht .pickup-location-text h4,
.eintracht .pickup-location-text .attention-inline {
  display: inline;
  font-family: AppFont, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 120%;
}
.eintracht .pickup-location-text h4 ::ng-deep strong, .eintracht .pickup-location-text h4.fw-bold,
.eintracht .pickup-location-text h4 span,
.eintracht .pickup-location-text .attention-inline ::ng-deep strong,
.eintracht .pickup-location-text .attention-inline.fw-bold,
.eintracht .pickup-location-text .attention-inline span {
  font-weight: 400;
}
.eintracht .pickup-location-text h4 + h4::before,
.eintracht .pickup-location-text h4 + .attention-inline::before {
  content: " ";
}
.eintracht ion-card-content {
  padding: 0;
}
.eintracht .item-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: 15px 21px 13px;
  border-bottom: 1px solid #383838;
}
.eintracht .item-row:last-child {
  padding-bottom: 13px;
  border-bottom: 1px solid #383838;
}
.eintracht .item-row ion-col {
  flex: 0 0 auto !important;
  width: auto !important;
  max-width: none !important;
}
.eintracht .item-row .article-name:first-child {
  width: 135px !important;
}
.eintracht .item-row .option-block {
  width: 100% !important;
}
.eintracht .item-row .article-quantity {
  margin-left: auto;
  text-transform: none;
}
.eintracht .item-row .article-quantity .quantity-number {
  font-size: 20px;
}
.eintracht .item-row .article-quantity .quantity-x {
  margin-left: 2px;
  font-size: 12px;
}
.eintracht .item-row .article-price {
  margin-left: 27px;
  text-align: right;
}
.eintracht .article-price {
  white-space: nowrap;
}
.eintracht .article-name,
.eintracht .article-price {
  font-family: EintrachtDisplaySublineCondensed;
  font-size: 20px;
  font-weight: 400;
  line-height: 110%;
  text-transform: uppercase;
}
.eintracht .footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  margin-top: auto;
  padding: 0;
}
.eintracht .footer::before {
  content: "";
  position: absolute;
  left: -20px;
  right: -20px;
  bottom: 0;
  height: 208px;
  background: linear-gradient(180deg, rgba(18, 18, 18, 0) 12%, #121212 83%);
  pointer-events: none;
  z-index: -1;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/payment-success.page.scss"],"names":[],"mappings":"AAEA;EACC,0DAAA;EACA,4BAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EAEA,sBAAA;AAFD;AAIC;EACC,WAAA;EACA,uCAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAFF;;AAMA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AAHD;;AAMA;EACC,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAHD;;AAMA;EACC,YAAA;EACA,aAAA;AAHD;;AAMA;EACC,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;AAHD;;AAMA;EACC,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAHD;;AAMA;EACC,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAHD;AAIC;EACC,cAAA;AAFF;;AAMA;EACC,cAAA;AAHD;AAIC;EACC,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAFF;AAGE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AADH;AAOC;EACC,cAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,UAAA;EACA,eAAA;AALF;AAME;EACC,WAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,oBAAA;AAJH;AAKG;EACC,gBAAA;AAHJ;AAKG;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;AAHJ;AAII;EACC,cAAA;EACA,mBAAA;AAFL;AAME;EACC,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,cAAA;AAJH;AAOE;EACC,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2DAAA;EACA,cAAA;EACA,sBAAA;AALH;AAMG;EACC,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,mBAAA;EAIA,4DAAA;AAPJ;AAII;EACC,kBAAA;AAFL;AAMI;EACC,yBAAA;EACA,gBAAA;EACA,oBAAA;AAJL;AAWI;EACC,UAAA;EACA,YAAA;AATL;AAWI;EACC,aAAA;AATL;AAYG;EACC,mCAAA;EACA,yBAAA;EACA,eAAA;AAVJ;AAYG;EACC,SAAA;AAVJ;AAcG;EACC,gBAAA;AAZJ;AAeG;EACC,iBAAA;AAbJ;;AAmBA;EACC,4BAAA;EACA,gCAAA;AAhBD;AAiBC;EACC,mBAAA;EACA,oBAAA;AAfF;;AAwBA;EACC,UAAA;EAEA,mCAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AAtBD;;AAyBA;EACC,UAAA;EAEA,mCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;AAvBD;;AAyBA;EACC,UAAA;AAtBD;;AAyBA;EACC,mCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AAtBD;;AAyBA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAtBD;;AAyBA;EACC,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,oDAAA;AAtBD;AAuBC;;EAEC,mCAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AArBF;;AAyBA;EACC,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,oDAAA;AAtBD;AAwBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;AAtBF;AAyBC;;EAEC,mCAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;AAvBF;;AA2BA;EACC,yBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AAxBD;AAyBC;;EAEC,mCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAvBF;;AA2BA;EACC,WAAA;EAEA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAzBD;;AA4BA;EACC,mBAAA;EACA,0BAAA;EACA,cAAA;EACA,oBAAA;AAzBD;AA0BC;EACC,gCAAA;AAxBF;AAyBE;EACC,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAvBH;AAyBE;EACC,aAAA;AAvBH;AAwBG;EACC,iBAAA;AAtBJ;;AA4BA;EACC,aAAA;EACA,8BAAA;EACA,iBAAA;AAzBD;AA0BC;EACC,UAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAxBF;AAyBE;EACC,WAAA;EACA,WAAA;EACA,yBAAA;AAvBH;AAwBG;EACC,sBAAA;EACA,4BAAA;AAtBJ;;AA2BA;EACC;IAEC,wCAAA;IACA,UAAA;EAzBA;EA2BD;IACC,wCAAA;IACA,YAAA;EAzBA;AACF;AA2BA;EACC;IAEC,yBAAA;IACA,UAAA;EA1BA;EA4BD;IACC,yBAAA;IACA,YAAA;EA1BA;AACF;AA4BA;EACC,yBAAA;EACA,gCAAA;AA1BD;AA2BC;EACC,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAzBF;AA0BE;EACC,gBAAA;AAxBH;;AA4BA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AAzBD;;AA4BA;EACC,mBAAA;AAzBD;AA4BC;EACC,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AA1BF;;AA+BA;EACC,qBAAA;AA5BD;AA8BC;EACC,mBAAA;AA5BF;AA8BE;EACC,aAAA;AA5BH;AAgCC;EACC,2BAAA;AA9BF;AAgCE;EACC,2BAAA;EACA,SAAA;EACA,oBAAA;AA9BH;AAgCG;EACC,YAAA;EACA,uBAAA;AA9BJ;AAiCG;EACC,qBAAA;EACA,8CAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,gDAAA;EACA,cAAA;EACA,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA/BJ;AAiCI;EACC,UAAA;AA/BL;AAsCC;EACC,oBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AApCF;AAsCE;EACC,mBAAA;EACA,SAAA;AApCH;AAuCE;EACC,aAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;AArCH;AAuCG;;EAEC,uBAAA;EACA,wBAAA;EACA,kBAAA;AArCJ;AA0CC;EACC,SAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAxCF;AA2CC;;EAEC,SAAA;EACA,UAAA;EACA,cAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAzCF;AA6CC;EACC,gBAAA;AA3CF;AA8CC;EACC,mBAAA;EACA,aAAA;AA5CF;AAgDC;EACC,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AA9CF;AAgDE;EACC,uBAAA;EACA,gCAAA;AA9CH;AAgDG;EACC,cAAA;EACA,gCAAA;AA9CJ;AAiDG;EACC,SAAA;EACA,UAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA/CJ;AAkDG;EACC,gBAAA;AAhDJ;AAqDC;EACC,oBAAA;EACA,gCAAA;AAnDF;AAqDE;EACC,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAnDH;AAqDG;EACC,gBAAA;AAnDJ;AAwDC;EACC,QAAA;EACA,oBAAA;AAtDF;AAwDE;EACC,WAAA;EACA,OAAA;AAtDH;AAwDG;EACC,WAAA;EACA,yBAAA;AAtDJ;AAwDI;EACC,mBAAA;EACA,sCAAA;AAtDL;AA6DE;EACC,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA3DH;AA6DG;EACC,UAAA;EACA,uBAAA;EACA,cAAA;AA3DJ;AAgEE;;EAEC,eAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA9DH;AAgEG;;;;;EAGC,gBAAA;AA5DJ;AAgEE;;EAEC,YAAA;AA9DH;AAkEC;EACC,UAAA;AAhEF;AAmEC;EACC,aAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,gCAAA;AAjEF;AAmEE;EACC,oBAAA;EACA,gCAAA;AAjEH;AAqEE;EACC,yBAAA;EACA,sBAAA;EACA,0BAAA;AAnEH;AAsEE;EACC,uBAAA;AApEH;AAuEE;EACC,sBAAA;AArEH;AAwEE;EACC,iBAAA;EACA,oBAAA;AAtEH;AAwEG;EACC,eAAA;AAtEJ;AAyEG;EACC,gBAAA;EACA,eAAA;AAvEJ;AA2EE;EACC,iBAAA;EACA,iBAAA;AAzEH;AA8EC;EACC,mBAAA;AA5EF;AA+EC;;EAEC,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA7EF;AAgFC;EACC,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;AA9EF;AAiFE;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,yEAAA;EACA,oBAAA;EACA,WAAA;AA/EH","sourcesContent":["@import '../../../theme/mixins';\n\n.background-overlay {\n\tbackground-image: url('../../../assets/eintracht/email-confiramation-header-bg.png');\n\tbackground-repeat: no-repeat;\n\tbackground-position: top center;\n\tbackground-size: auto;\n\tposition: relative;\n\t// background-color: #121212cc;\n\tbackground-color: #000;\n\n\t&::before {\n\t\tcontent: '';\n\t\tbackground-color: #121212cc;\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\tz-index: 1;\n\t}\n}\n\n.header {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 60px 0 20px;\n}\n\n.awaiting-subtitle {\n\tfont-family: var(--ion-font-family);\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tline-height: 140%;\n\ttext-align: center;\n\tcolor: #ffffff;\n\tmargin: 12px 0 0;\n\tpadding: 0 10px;\n}\n\n.qr-placeholder {\n\twidth: 225px;\n\theight: 225px;\n}\n\n.awaiting-secondary {\n\tfont-family: var(--ion-font-family);\n\tfont-size: 12px;\n\tfont-weight: 400;\n\tline-height: 130%;\n\ttext-align: center;\n\tcolor: #ffffffcc;\n\tmargin: 80px 0 0;\n\tpadding: 0 10px;\n}\n\n.logo {\n\t--icon-color: black;\n\theight: 36px;\n\twidth: 85px;\n\tmargin-bottom: 20px;\n}\n\n.title {\n\tfont-family: var(--ion-font-family);\n\tfont-weight: 700;\n\tfont-size: 22px;\n\tline-height: 130%;\n\tletter-spacing: 0;\n\ttext-align: center;\n\tvertical-align: middle;\n\t&.accent {\n\t\tcolor: #ffffff;\n\t}\n}\n\n.container-all {\n\theight: 100dvh;\n\t.wrapper-left {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-self: center;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\toverflow: auto;\n\t\tbackground: #faf7f6;\n\t\tion-img {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t\t// background: url('') no-repeat center center / 105% 105%;\n\t\t// background-size: cover;\n\t\t// background-position: center;\n\t}\n\t&.wrapper-info {\n\t\toverflow: auto;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tflex-direction: column;\n\t\tz-index: 1;\n\t\tpadding: 0 20px;\n\t\tion-button {\n\t\t\twidth: 100%;\n\t\t\ttext-wrap: auto;\n\t\t\tbackground-color: #fff;\n\t\t\tcolor: #231f20;\n\t\t\tfont-family: var(--ion-font-family);\n\t\t\tfont-size: 16px;\n\t\t\tfont-weight: 700;\n\t\t\tline-height: 130%;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\tpadding: 0;\n\t\t\tmin-height: 50px;\n\t\t\ttext-transform: none;\n\t\t\tspan {\n\t\t\t\tpadding-top: 3px;\n\t\t\t}\n\t\t\t&.btn-eintracht {\n\t\t\t\tfont-family: AppFontEintrachtOFCSans;\n\t\t\t\tbackground-color: #e30613;\n\t\t\t\tborder-radius: 6px;\n\t\t\t\tcursor: pointer;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tfont-size: 1rem;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tborder: none;\n\t\t\t\tcolor: #fff;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\t--border-color: transparent;\n\t\t\t\tz-index: 1;\n\t\t\t\tspan {\n\t\t\t\t\tpadding-top: 0;\n\t\t\t\t\tpadding-bottom: 3px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.main-card {\n\t\t\tflex-grow: 1;\n\t\t\tbackground: #231f20;\n\t\t\tborder-radius: 5px 5px 0 0;\n\t\t\tcolor: #ffffff;\n\t\t}\n\n\t\tion-card {\n\t\t\ttext-align: initial;\n\t\t\tborder: none;\n\t\t\tbox-shadow: none;\n\t\t\tbackground: transparent;\n\t\t\t--color: var(--color-black);\n\t\t\t--preorder-type-chip-border-color: var(--ion-color-primary);\n\t\t\toverflow: auto;\n\t\t\tword-break: break-word;\n\t\t\tion-card-header {\n\t\t\t\tbackground: white;\n\t\t\t\tcolor: var(--color-black);\n\t\t\t\tpadding: 0;\n\t\t\t\tpadding-bottom: 8px;\n\t\t\t\t.separator {\n\t\t\t\t\tmargin-block: 20px;\n\t\t\t\t}\n\t\t\t\tborder-bottom: 0.3px solid #7ea76973;\n\n\t\t\t\tion-button {\n\t\t\t\t\t--background: transparent;\n\t\t\t\t\t--color: #54504c;\n\t\t\t\t\ttext-transform: none;\n\t\t\t\t}\n\t\t\t}\n\t\t\tion-card-content {\n\t\t\t\t// border-top: 0.3px solid #7ea76973;\n\t\t\t\t// padding: 10px 0px 0px 0px;\n\t\t\t\t// line-break: auto !important;\n\t\t\t\t&:first-of-type {\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tborder: none;\n\t\t\t\t}\n\t\t\t\t.padding-card {\n\t\t\t\t\tpadding: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t\tion-card-title {\n\t\t\t\tfont-family: var(--ion-font-family);\n\t\t\t\tcolor: var(--color-white);\n\t\t\t\tfont-size: 18px;\n\t\t\t}\n\t\t\t.icon-edit {\n\t\t\t\tzoom: 1.3;\n\t\t\t}\n\t\t\tion-col {\n\t\t\t}\n\t\t\t.left-col {\n\t\t\t\ttext-align: left;\n\t\t\t}\n\n\t\t\t.right-col {\n\t\t\t\ttext-align: right;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.item-row {\n\tpadding: 25px 20px 20px 20px;\n\tborder-bottom: 1px solid #383838;\n\t&:last-child {\n\t\tborder-bottom: none;\n\t\tpadding-bottom: 30px;\n\t}\n}\n\n.article-price,\n.article-name {\n\t// margin-bottom: 10px;\n}\n\n.article-name {\n\tpadding: 0;\n\n\tfont-family: var(--ion-font-family);\n\tfont-size: 12px;\n\tline-height: 120%;\n\ttext-transform: capitalize;\n}\n\n.article-price {\n\tpadding: 0;\n\n\tfont-family: var(--ion-font-family);\n\tfont-size: 12px;\n\tline-height: 120%;\n\tvertical-align: middle;\n\ttext-transform: capitalize;\n}\n.option-block {\n\tpadding: 0;\n}\n\n.option-name {\n\tfont-family: var(--ion-font-family);\n\tfont-size: 10px;\n\tline-height: 120%;\n\tletter-spacing: 0%;\n\tvertical-align: bottom;\n\ttext-transform: uppercase;\n\tmargin-bottom: 3px;\n}\n\n.footer {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.table-row {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 10px 18px;\n\tborder-bottom: 1px solid #0000004d;\n\t.table-title,\n\t.table-sum {\n\t\tfont-family: var(--ion-font-family);\n\t\tcolor: var(--color-white);\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: right;\n\t\tvertical-align: bottom;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.total-row {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 0;\n\tpadding: 10px 18px;\n\tborder-bottom: 1px solid #0000004d;\n\n\t.total {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tpadding: 0;\n\t\twidth: 100%;\n\t}\n\n\t.total-title,\n\t.total-sum {\n\t\tfont-family: var(--ion-font-family);\n\t\tcolor: var(--color-white);\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: right;\n\t\tvertical-align: bottom;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.sub-total {\n\tcolor: var(--color-white);\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 0;\n\tmargin-bottom: 8px;\n\t.sub-total-title,\n\t.sub-total-sum {\n\t\tfont-family: var(--ion-font-family);\n\t\tfont-size: 10px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 8%;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\t}\n}\n\n.button-block {\n\twidth: 100%;\n\t// padding: 25px 0;\n\tpadding-bottom: 25px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 15px;\n}\n\n.main-card-wrapper {\n\tbackground: #231f20;\n\tborder-radius: 5px 5px 0 0;\n\tcolor: #ffffff;\n\tmargin-bottom: -20px;\n\t.pickup-location {\n\t\tborder-bottom: 1px solid #383838;\n\t\tp {\n\t\t\tfont-family: var(--ion-font-family);\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 130%;\n\t\t\tmargin-top: 20px;\n\t\t\tmargin-bottom: 28px;\n\t\t\tpadding: 0 20px;\n\t\t}\n\t\t.pickup-location__content {\n\t\t\tdisplay: flex;\n\t\t\t.pickup-location-text {\n\t\t\t\tmargin-left: 15px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.header-sliders {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 15px 0px;\n\t.step {\n\t\twidth: 32%;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\t.line {\n\t\t\twidth: 100%;\n\t\t\theight: 9px;\n\t\t\tbackground-color: #383838;\n\t\t\t&.selected {\n\t\t\t\tbackground-color: #fff;\n\t\t\t\tanimation: pulse 2s infinite;\n\t\t\t}\n\t\t}\n\t}\n}\n@keyframes pulse {\n\t0%,\n\t100% {\n\t\tbackground-color: var(--ion-color-white);\n\t\topacity: 1;\n\t}\n\t50% {\n\t\tbackground-color: var(--ion-color-white);\n\t\topacity: 0.5;\n\t}\n}\n@keyframes pulse-eintracht {\n\t0%,\n\t100% {\n\t\tbackground-color: #d10d1d;\n\t\topacity: 1;\n\t}\n\t50% {\n\t\tbackground-color: #d10d1d;\n\t\topacity: 0.5;\n\t}\n}\n.pickup-status {\n\tpadding: 20px 20px 0 20px;\n\tborder-bottom: 1px solid #383838;\n\th3 {\n\t\tfont-family: var(--ion-font-family);\n\t\tfont-weight: 700;\n\t\tfont-size: 20px;\n\t\tline-height: 100%;\n\t\tvertical-align: middle;\n\t\tspan {\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n}\n.burger-menu {\n\tposition: absolute;\n\ttop: 15px;\n\tleft: 20px;\n\tz-index: 1;\n}\n\n.eintracht-header {\n\tbackground: #000000;\n\n\t// global.scss forces padding-top: max(safe-area, 7px) on every toolbar\n\tion-toolbar {\n\t\tpadding-right: 0;\n\t\tpadding-bottom: 0;\n\t\tpadding-left: 0;\n\t\t--background: #000000;\n\t\t--min-height: 0;\n\t\t--padding-top: 12px;\n\t\t--padding-bottom: 0;\n\t\t--padding-start: 20px;\n\t\t--padding-end: 20px;\n\t}\n}\n\n// Figma: AMEX updates / Screen 3 + Screen 4\n.eintracht {\n\t--background: #000000;\n\n\t.background-overlay {\n\t\tbackground: #000000;\n\n\t\t&::before {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t.container-all {\n\t\theight: calc(100dvh - 50px);\n\n\t\t&.wrapper-info {\n\t\t\tjustify-content: flex-start;\n\t\t\tgap: 16px;\n\t\t\tpadding: 32px 20px 0;\n\n\t\t\t.main-card {\n\t\t\t\tflex-grow: 0;\n\t\t\t\tbackground: transparent;\n\t\t\t}\n\n\t\t\tion-button.btn-eintracht {\n\t\t\t\t--background: #ffffff;\n\t\t\t\t--border-color: var(--ion-color-eintracht-red);\n\t\t\t\t--border-width: 1px;\n\t\t\t\t--border-style: solid;\n\t\t\t\t--border-radius: 6px;\n\t\t\t\t--box-shadow: none;\n\t\t\t\theight: 50px;\n\t\t\t\tmin-height: 50px;\n\t\t\t\tmargin: 0;\n\t\t\t\tbackground: #ffffff;\n\t\t\t\tborder: 1px solid var(--ion-color-eintracht-red);\n\t\t\t\tcolor: #000000;\n\t\t\t\tfont-family: AppFontEintrachtSansOFCBold;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 130%;\n\n\t\t\t\tspan {\n\t\t\t\t\tpadding: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// card 1: QR code, or \"QR code coming\" info while awaiting confirmation\n\t.header {\n\t\talign-items: stretch;\n\t\tgap: 8px;\n\t\tpadding: 20px 16px;\n\t\tbackground: #232323;\n\t\tborder-radius: 20px;\n\n\t\t&:has(qrcode) {\n\t\t\talign-items: center;\n\t\t\tgap: 16px;\n\t\t}\n\n\t\tqrcode {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\theight: 163px;\n\t\t\tline-height: 0;\n\n\t\t\t::ng-deep canvas,\n\t\t\t::ng-deep img {\n\t\t\t\twidth: 163px !important;\n\t\t\t\theight: 163px !important;\n\t\t\t\tborder-radius: 6px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.title {\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tbackground: transparent;\n\t\tcolor: #ffffff;\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-weight: 700;\n\t\tfont-size: 18px;\n\t\tline-height: 120%;\n\t\ttext-align: left;\n\t}\n\n\t.awaiting-subtitle,\n\t.awaiting-secondary {\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tcolor: #ffffff;\n\t\tfont-family: AppFont, sans-serif;\n\t\tfont-weight: 400;\n\t\tfont-size: 16px;\n\t\tline-height: 120%;\n\t\ttext-align: left;\n\t}\n\n\t// Figma separates the two paragraphs with one empty line (19px, minus the 8px card gap)\n\t.awaiting-secondary {\n\t\tmargin-top: 11px;\n\t}\n\n\th2.awaiting-secondary {\n\t\talign-self: stretch;\n\t\tmargin-top: 0;\n\t}\n\n\t// card 2: status, order number, ordered articles\n\t.main-card-wrapper {\n\t\tmin-height: 500px;\n\t\tmargin-bottom: 0;\n\t\tbackground: #232323;\n\t\tborder-radius: 20px;\n\t\toverflow: hidden;\n\n\t\t.pickup-location {\n\t\t\tpadding: 48px 21px 16px;\n\t\t\tborder-bottom: 1px solid #383838;\n\n\t\t\t.pickup-location__content .pickup-location-text {\n\t\t\t\tmargin-left: 0;\n\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t}\n\n\t\t\tp {\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 120%;\n\t\t\t}\n\n\t\t\t.amex-farewell {\n\t\t\t\tmargin-top: 24px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.pickup-status {\n\t\tpadding: 20px 21px 0;\n\t\tborder-bottom: 1px solid #383838;\n\n\t\th3 {\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 100%;\n\n\t\t\tspan {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n\n\t.header-sliders {\n\t\tgap: 8px;\n\t\tpadding: 11px 0 15px;\n\n\t\t.step {\n\t\t\twidth: auto;\n\t\t\tflex: 1;\n\n\t\t\t.line {\n\t\t\t\theight: 9px;\n\t\t\t\tbackground-color: #0f0f0f;\n\n\t\t\t\t&.selected {\n\t\t\t\t\tbackground: #d10d1d;\n\t\t\t\t\tanimation: pulse-eintracht 2s infinite;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.pickup-location-text {\n\t\th3.order-number {\n\t\t\tmargin: 0 0 11px;\n\t\t\tfont-family: AppFontEintrachtOFC;\n\t\t\tfont-size: 28px;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 110%;\n\t\t\ttext-transform: uppercase;\n\n\t\t\tspan {\n\t\t\t\tpadding: 0;\n\t\t\t\tbackground: transparent;\n\t\t\t\tcolor: #ffffff;\n\t\t\t}\n\t\t}\n\n\t\t// status text + attention text read as one paragraph\n\t\th4,\n\t\t.attention-inline {\n\t\t\tdisplay: inline;\n\t\t\tfont-family: AppFont, sans-serif;\n\t\t\tfont-size: 16px;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 120%;\n\n\t\t\t::ng-deep strong,\n\t\t\t&.fw-bold,\n\t\t\tspan {\n\t\t\t\tfont-weight: 400;\n\t\t\t}\n\t\t}\n\n\t\th4 + h4::before,\n\t\th4 + .attention-inline::before {\n\t\t\tcontent: \" \";\n\t\t}\n\t}\n\n\tion-card-content {\n\t\tpadding: 0;\n\t}\n\n\t.item-row {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\talign-items: flex-start;\n\t\tpadding: 15px 21px 13px;\n\t\tborder-bottom: 1px solid #383838;\n\n\t\t&:last-child {\n\t\t\tpadding-bottom: 13px;\n\t\t\tborder-bottom: 1px solid #383838;\n\t\t}\n\n\t\t// ion-col writes its size as inline flex/width/max-width\n\t\tion-col {\n\t\t\tflex: 0 0 auto !important;\n\t\t\twidth: auto !important;\n\t\t\tmax-width: none !important;\n\t\t}\n\n\t\t.article-name:first-child {\n\t\t\twidth: 135px !important;\n\t\t}\n\n\t\t.option-block {\n\t\t\twidth: 100% !important;\n\t\t}\n\n\t\t.article-quantity {\n\t\t\tmargin-left: auto;\n\t\t\ttext-transform: none;\n\n\t\t\t.quantity-number {\n\t\t\t\tfont-size: 20px;\n\t\t\t}\n\n\t\t\t.quantity-x {\n\t\t\t\tmargin-left: 2px;\n\t\t\t\tfont-size: 12px;\n\t\t\t}\n\t\t}\n\n\t\t.article-price {\n\t\t\tmargin-left: 27px;\n\t\t\ttext-align: right;\n\t\t}\n\n\t}\n\n\t.article-price {\n\t\twhite-space: nowrap;\n\t}\n\n\t.article-name,\n\t.article-price {\n\t\tfont-family: EintrachtDisplaySublineCondensed;\n\t\tfont-size: 20px;\n\t\tfont-weight: 400;\n\t\tline-height: 110%;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.footer {\n\t\tposition: sticky;\n\t\tbottom: 0;\n\t\tz-index: 2;\n\t\tmargin-top: auto;\n\t\tpadding: 0;\n\n\t\t// Figma: 208px fade to #121212 behind the button, overlapping the cards\n\t\t&::before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: -20px;\n\t\t\tright: -20px;\n\t\t\tbottom: 0;\n\t\t\theight: 208px;\n\t\t\tbackground: linear-gradient(180deg, rgba(18, 18, 18, 0) 12%, #121212 83%);\n\t\t\tpointer-events: none;\n\t\t\tz-index: -1;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
